<template>
    <div class="batchBox">
        <div class="batch">
            <div class="templateBtn" @click="download">下载模板</div>


        </div>
        <el-upload
                class="upload-demo"
                :limit="1"
                :on-success="handleSuccess"
                accept=".xlsx,.xls"
                :headers="headers"
                :action="url"
                :on-exceed="handleExceed"
                name="file">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">请先在下载的Excel模板中添加数据，然后点击此处导入填好的Excel</div>
        </el-upload>

    </div>
</template>

<script>
    import { mediationTemplate } from '../../../api/mediateCase';

    export default {
        name: 'batchImport',
        data() {
            return {
                url:process.env.VUE_APP_BASE_API+'/api/tiaojie_case_batch_import',
                headers: {
                    'Authorization': sessionStorage.getItem('token'),
                    'Comid': sessionStorage.getItem('shenfen'),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
                }
            };
        },
        methods: {
            //下载模板
            download() {
                mediationTemplate().then(res => {
                    if (res.code == 200) {
                        const link = document.createElement('a'); //自己创建的a标签
                        link.href = res.data.download_url;
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                    }
                });
            },
            //批量提交
            submitBtn() {
            },
            handleSuccess(response, file, fileList) {
                if (response.code == 200) {
                    this.$message.success(response.msg);
                    this.$router.push('/mediate');
                } else if (response.code == 400) {
                    this.$message.error(response.msg);
                } else {
                    this.$message.error(response.msg);
                }
            },
            handleExceed(files, fileList) {
                if (fileList.length >= 1) {
                    this.$message.error('只能上传1个文件');
                }
            }

        },
        created() {
            this.headers.Comid = JSON.parse(sessionStorage.getItem('shenfen')).com_id;
        }
    };
</script>

<style scoped>
    .batchBox {
        padding: 30px;
        background-color: #fff;
        border-right: 5px;
    }

    .batch {
        display: flex;
    }

    .batch > div {
        margin-right: 20px;
    }

    .templateBtn {
        width: 100px;
        height: 40px;
        background-color: #3e62f6;
        color: #fff;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }

    .upload-demo {
        margin-top: 20px;
    }
</style>
